















































































































import Vue from './report.mixin'
import { Template, CreateTemplate } from '@/api/report'
import FieldEditor from './fields.vue'
export default Vue.extend({
  name: 'NewReport',
  components: { FieldEditor },
  data() {
    return {
      file: undefined as File | undefined,
      form: {
        name: '',
        query: 'mean(value) AS nilai',
        timeGroup: '1m',
        timeFormat: 'YYYY-MM-DD hh:mm:ss',
        sheetname: 'Sheet1',
        dataDuration: '1h',
        fieldTime1Format: 'YYYY-MM-DD',
        fieldTime2Format: 'hh:mm:ss',
      } as Template,
    }
  },

  methods: {
    async createTemplate() {
      if (this.file != undefined) {
        await CreateTemplate(this.form, this.file)
        this.gotoReport()
      }
    },

    gotoReport() {
      this.$router.push('/cems/setting/report')
    },
  },
})
